
import {Component, Prop, Vue} from "vue-property-decorator";
import {isBranchingFieldType, isParentFieldType} from "@/auxillary/datafield.cache.helpers";
import {stringify} from "@/auxillary/datafield.stringify";
import {DataFieldChangeType, IDataFieldChangeReport} from "@/auxillary/datafield.changes";
import DataFieldChangeReason from "@/components/study/dataFieldChange/DataFieldChangeReason.vue";

@Component({
  components: {DataFieldChangeReason, 'changed-data-field': () => import('./ChangedDataField.vue')}
})
export default class ChangedDataField extends Vue {
  @Prop({required: true}) changedDataFieldReport!: IDataFieldChangeReport;

  get hasIcon() {
    return this.changedDataFieldReport.changeType != DataFieldChangeType.NONE;
  }

  get icon() {
    if (this.changedDataFieldReport.changeType == DataFieldChangeType.UPDATE)
      return "fa-pen";
    if (this.changedDataFieldReport.changeType == DataFieldChangeType.DELETE)
      return "fa-trash-alt";
    return "";
  }

  get iconColor() {
    if (this.changedDataFieldReport.changeType == DataFieldChangeType.UPDATE)
      return "primary";
    if (this.changedDataFieldReport.changeType == DataFieldChangeType.DELETE)
      return "error";
    return "";
  }

  get dataFieldCache() {
    return this.changedDataFieldReport.dataFieldCache;
  }

  get childFields() {
    return this.changedDataFieldReport.childFields ?? [];
  }

  get hasChildFieldsWithValues() {
    return this.changedDataFieldReport.hasChildFieldsWithValues ?? false;
  }

  get displayName() {
    return this.dataFieldCache.displayName;
  }

  get displayValue() {
    return isParentFieldType(this.definitionType) ? "" : "Neuer Wert: " + stringify(this.dataFieldCache) ?? "";
  }

  get definitionType() {
    return this.dataFieldCache.definitionType ?? "";
  }

  get fieldValueChanges() {
    return this.changedDataFieldReport.changeType == DataFieldChangeType.UPDATE;
  }

  get isListEntry() {
    return isBranchingFieldType(this.definitionType);
  }

  get isGroupEntry() {
    return isParentFieldType(this.definitionType);
  }

  get hasChildNames() {
    return isBranchingFieldType(this.dataFieldCache.definitionType);
  }

  get childNames() {
    return this.dataFieldCache.definition.names ?? [{
      template: "{0}",
      field: ["name"]
    }];
  }

  get childName() {

    let name = "";

    for (const childName of this.childNames) {
      if (!childName.field) {
        name += childName.template;
        continue
      }

      // find field
      let field: any = undefined;
      for (const fieldIdentifier of childName.field) {
        if (field === undefined) {
          // The naming field itself is usually unchanged, so the change reports would not hold it.
          field = this.dataFieldCache.childFields.find(d => d.identifier == fieldIdentifier)
          if (field === undefined)
            break;
          continue;
        }

        field = field.childFields.find((d: any) => d.identifier == fieldIdentifier)
        if (field === undefined)
          break;
      }
      if (field?.values == null)
        continue;

      const fieldName = stringify(field);
      if (fieldName)
        name += childName.template.replace("{0}", fieldName);
    }

    if (name == "")
      return "(keine Eintragung)";

    return name;
  }

  get needsReasonForChange() {
    return this.changedDataFieldReport.needsReasonForChange;
  }
}
